import React, { useEffect, useState } from "react";
import {
  Accordion,
  AccordionItem,
  AccordionButton,
  AccordionPanel,
  AccordionIcon,
  Box,
  Flex,
  VStack,
  HStack,
  Text,
  Stack
} from "@chakra-ui/react";
import SubtopicCollection from "./SubtopicCollection";
import Checkbox from "./Checkbox";

interface TopicProps {
  tags: string[]; // may be replaced with ID in future
  //id: string;
  title: string;
  // childIds: string[]
  childContent: any[];
  toggleGameLiftStreamsInput: any;
}

const Topic: React.FC<TopicProps> = ({ tags, title, childContent, toggleGameLiftStreamsInput}) => {

  //this handles the accordion dropdown state
  const [isOpen, setIsOpen] = useState(false);

  //this sets the checked state for the subtopic
  //const [subtopicCheckedState, setSubtopicCheckedState] = useState<boolean | null>(null);

  const toggleAccordion = () => {
    setIsOpen(!isOpen);
  };
  return (
    <Box
/*       p={3}
      m={3} */
      bg="gray.700"
      borderRadius="10px"
      position="relative"
      w="100%"
    >
      <Accordion>
        <AccordionItem border="none" isDisabled={false} isFocusable={true}>
          {({ isExpanded }) => (
            <>
              <HStack width="270px" justify="left">
                <AccordionButton onClick={toggleAccordion} width="5%" justifyContent="center" p={0}>
                  <AccordionIcon transform={isOpen ? "rotate(180deg)" : ""}/>
                </AccordionButton>
                <Checkbox tags={[ ...tags, "overall" ]}/>
                <AccordionButton onClick={toggleAccordion} p={0}>
                  <Text as="span" textAlign="left" fontSize="15px" fontWeight="300" color="E5E5E5">
                    {title}
                  </Text>
                </AccordionButton>
              </HStack>
              {isOpen && (
                <SubtopicCollection tags={tags} childContent={childContent} toggleGameLiftStreamsInput={toggleGameLiftStreamsInput}/>
              )}
            </>
          )}
        </AccordionItem>
      </Accordion>
      {!isOpen && <div style={{ height: 0, overflow: "hidden" }}></div>}
    </Box>
  );
}

export default Topic;
